import script from "./FinishStudyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishStudyDialog.vue?vue&type=script&setup=true&lang=js"

import "./FinishStudyDialog.vue?vue&type=style&index=0&id=412163f6&scoped=true&lang=less"
import "./FinishStudyDialog.vue?vue&type=style&index=1&id=412163f6&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-412163f6"]])

export default __exports__